require('./bridges-list-view.style.less');
require('./bridges-list-view-template.html');

angular.module('bbl.dashboard.directive.bridges-list-view', [])
	.directive('bridgesListView', [function() {
		return {
			restrict: 'E',
			templateUrl: 'bridges-list-view-template.html',
			scope: {
        toggleHoldMute: '&',
				onBridgeSelect: '&',
				onAddLine: '&',
        active: '=',
        conference: '=',
				bridges: '=',
				permissions: '=',
				allowScreenshare: '=',
			},

			link: function($scope, $el, atts) {},
			controller: ['$scope', 'CallManager', 'Toast', 'Api', 'Auth', BridgesListViewController]
		};
	}]);

function BridgesListViewController($scope, CallManager, Toast, Api, Auth) {
	Auth.getUserInfo().then(function(user) {
		$scope.user = {
			email: user.email,
			name: (user.first_name||'')+' '+(user.last_name||''),
			company: (user.company||{}).name,
		};
	}).catch(angular.noop);

	$scope.c = {
		pag: {min: 7, max: 9999, take: 7, page: 0}
	};

	$scope.pluralize = {
		callers: {
			0: 'Idle',
			one: '1 Caller Online.',
			other: '{} Callers Online.'
		}
	};

	$scope.callCount = function(bridge) {
		return bridge.in_progress_conferences_caller_count;
	};

  $scope.shareLink = function(bridge) {
    return bridge.short_url + "app/#join-call/" + bridge.token_link_anon + "?bid="+bridge.id;
  };

  $scope.screenLink = function(bridge) {
    return bridge.short_url + "app/#view-screen/"+bridge.token_link_anon+"?bid="+bridge.id;
  };

	$scope.joinFromBrowser = function(bridge) {
		if(CallManager.getCall()) {
			Toast.error("{{'You\\\'re already in a conference, please disconnect before joining another one!'|translate}}");
			return;
		}

		var call = CallManager.createCall(bridge);
	};

	$scope.lock = function(bridge) {
		bridge.locked =! bridge.locked;
		bridge.in_progress_conference_calls[0].lock();
	};

	$scope.hangupAll = function(bridge) {
		Api.bridges.hangupBridge(bridge);
	};

	$scope.muteAll = function(bridge) {
		Api.bridges.muteBridge(bridge);
	};

  $scope.deleteTiedLine = function (line) {
    Api.bridges.deleteDid(line.id).then(function() {
      Api.bridges.fetch({limit: 100}, {cache: false});
    }, Toast.error.bind(Toast, "{{'There was an error deleting the line'|translate}}!"));
  };
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/bridges-list-view/bridges-list-view.directive.js
 ** module id = 331
 ** module chunks = 0
 **/